import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MachineOrderService {

  constructor(private httpClient: HttpClient) { }

  post(order: any) {
    return this.httpClient.post(`${environment.nami_url}/order`, order);
  }

  postPixExam(order: any) {
    return this.httpClient.post(`${environment.nami_url}/pix/qrcode/exam`, order);
  }

  postPixService(order: any) {
    return this.httpClient.post(`${environment.nami_url}/pix/qrcode/service`, order);
  }

  update(orderId: any, order: any) {
    return this.httpClient.patch(`${environment.url}/update/status/revenue_payment_event/order/${orderId}`, order);
  }

  cancelOrder(orderId: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.httpClient.patch(`${environment.nami_url}/order/${orderId}/closed`, {status: 'canceled'}, {headers: headers});
  }
}
